import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { safeGet, safeSet } from "../lib/safeStorage";

const PricingContext=createContext(null);
const symbols={EUR:"€",USD:"$",GBP:"£"};
const normalizeRates=(payload)=>{
 const source=payload?.rates&&typeof payload.rates==="object"?payload.rates:{};
 const rates={EUR:String(source.EUR||"1")};
 for(const code of ["USD","GBP"]){const value=Number(source[code]);if(Number.isFinite(value)&&value>0)rates[code]=String(source[code])}
 return {rates,date:payload?.date||null,stale:Boolean(payload?.stale)||!rates.USD||!rates.GBP,loading:false};
};

export const PricingProvider=({children})=>{
 const [currency,setCurrency]=useState(()=>safeGet("aramfix-currency","EUR"));
 const [priceUnit,setPriceUnit]=useState(()=>{const stored=Number(safeGet("aramfix-price-unit"));return [1,100,1000].includes(stored)?stored:100});
 const [fx,setFx]=useState({rates:{EUR:"1"},date:null,stale:true,loading:true});
 useEffect(()=>{safeSet("aramfix-currency",currency)},[currency]);
 useEffect(()=>{safeSet("aramfix-price-unit",String(priceUnit))},[priceUnit]);
 useEffect(()=>{let cancelled=false;let timer;const load=()=>api.get("/pricing/exchange-rates").then(({data})=>{if(cancelled)return;const next=normalizeRates(data);setFx(next);if(next.stale)timer=setTimeout(load,5000)}).catch(()=>{if(cancelled)return;setFx(normalizeRates(null));timer=setTimeout(load,5000)});load();return()=>{cancelled=true;clearTimeout(timer)}},[]);
 useEffect(()=>{if(!fx.loading&&!fx.rates?.[currency])setCurrency("EUR")},[fx,currency]);
 const value=useMemo(()=>({currency,setCurrency,priceUnit,setPriceUnit,symbol:symbols[currency]||currency||"€",fx}),[currency,priceUnit,fx]);
 return <PricingContext.Provider value={value}>{children}</PricingContext.Provider>;
};

export const usePricing=()=>useContext(PricingContext);